module.exports = __webpack_public_path__ + "media/iconic/rocket-7cde36ca.svg";